import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Sticky bottom CTA shown on mobile after scrolling past the hero.
export const MobileCtaBar = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div data-testid="mobile-cta-bar" className="fixed bottom-0 left-0 z-40 w-full border-t border-slate-200 bg-white/95 px-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur-xl md:hidden">
      <div className="flex items-center gap-3">
        <div className="min-w-0">
          <p className="truncate text-sm font-black text-slate-900">Quote jobs in 2 minutes</p>
          <p className="truncate text-xs text-slate-500">Free 7 days · No credit card</p>
        </div>
        <Link to="/signup" data-testid="mobile-cta-signup" className="ml-auto shrink-0">
          <span className="flex h-12 items-center gap-1.5 rounded-xl bg-indigo-500 px-5 font-bold text-white active:bg-indigo-600">
            Start free trial <ArrowRight className="h-4 w-4" />
          </span>
        </Link>
      </div>
    </div>
  );
};
